export function DuplicateWarning({ match, onProceed, onCancel }) {
  return (
    <div className="rounded border border-amber-300 bg-amber-50 p-3 space-y-2">
      <p className="text-sm font-medium text-amber-800">Possible duplicate detected</p>
      <p className="text-xs text-amber-700">
        You already have an application for <span className="font-medium">{match.company}</span> — <span className="font-medium">{match.role}</span> (status: {match.status})
      </p>
      <div className="flex gap-2">
        <button onClick={onProceed} className="rounded bg-amber-600 px-3 py-1 text-xs font-medium text-white hover:bg-amber-700">Save Anyway</button>
        <button onClick={onCancel} className="rounded border border-amber-300 px-3 py-1 text-xs text-amber-700 hover:bg-amber-100">Cancel</button>
      </div>
    </div>
  );
}

/**
 * Check for duplicate company+role in existing applications.
 * @returns {Object|null} matching app or null
 */
export function findDuplicate(applications, company, role, excludeAppId) {
  const c = company.trim().toLowerCase();
  const r = role.trim().toLowerCase();
  return applications.find(
    (a) => a.appId !== excludeAppId && a.company?.trim().toLowerCase() === c && a.role?.trim().toLowerCase() === r
  ) || null;
}
